/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Вид для группы категорий.
   * Создаёт вид для каждой отдельной категории внутри себя.
   *
   * @param el {string} jQuery-селектор родительского элемента
   * @param itemEl {string} jQuery-селектор элемента категории
   */
  
  app.CategoriesView = app.View.extend({
    
    initialize: function () {
      this.$categories = this.$(this.itemEl);
      // создаём экземпляр View для каждого Category
      this.$categories.each(function () {
        new app.CategoryView({'el': $(this)});
      });
      
    }
    
  });
})(jQuery);

}.call(window));